<template>
  <div class="message-background rounted-lg">
    <div class="title-resume mb-3 accent--text">
      {{ $t("finished.organizerMessage") }}
    </div>
    <div class="checkout-h5 accent--text" v-html="message"></div>
  </div>
</template>

<script>
export default {
  props: ["message"],
};
</script>

<style scoped>
.message-background {
  background: #f1f7fd;
  padding: 20px;
}
.title-resume {
  line-height: normal !important;
  font-size: 18px !important;
  width: 89%;
}
</style>
